module.exports = "/_next/static/images/0ba8632e1e267d35cf3183451e4a4833-group-man-building@2x.jpg.webp";